import React from "react"
import {
  Modal,
  Button,
  FormGroup,
  FormControl,
  HelpBlock,
  ControlLabel,
} from "react-bootstrap"
import ProcessesStatus from "../fragments/ProcessesStatus"
import { blockingFetchService } from "../../lib/blockingFetch"
import apiServerApi from "../../redux/sagas/apiServerApi"
import moment from "moment"
import FieldGroup from "../FieldGroup"
import { initField } from "../../lib/form-builder"
import * as Validators from "../../lib/validators"

class EditTransactionModalScreen extends React.Component {

  constructor(props) {

    super(props)
    this.loanDate = moment(this.props.disburseDate).format('YYYY-MM-DD')

    this.state = {
      running: false,
      success: false,
      error: null,
      successText: null,

      transactionDate: this.props.transactionDate,
      ...initField(this, 'transactionAmount', this.props.transactionAmount, Validators.nonEmpty),
    }
  }

  componentDidMount() {
    this.dataValidation()
  }

  getDateValidationState() {

    try {
      const choosedDate = moment(this.state.transactionDate).startOf('day'),
      now = moment().startOf('day'),
      loanDate = moment(this.loanDate).startOf('day')

      return choosedDate.isBetween(loanDate, now, undefined, '[]') ? 'success' : 'error'
    }
    catch(e) {
      return 'error'
    }
  }

  dataValidation = () => this.state.transactionAmount.validationCurrentValue()

  checkData = () => !!(
    this.getDateValidationState() === 'success' &&
    this.state.transactionAmount.validation &&
    this.state.transactionAmount.validation.valid
  )

  makeAction = () => {

    const { loanId, transactionId, transactionAmount } = this.props

    if(transactionAmount && !this.checkData()) {
      this.dataValidation()
      this.setState({ error: 'The transaction amount or date is incorrect!' })
      return
    }

    this.setState({
      running: true,
      success: false,
      error: null,
      successText: null,
    })

    blockingFetchService(
      accessToken => apiServerApi.updateTransaction(
        accessToken, loanId, transactionId, this.state.transactionDate, this.state.transactionAmount.value), 
      response => {

        this.setState({ success: true, successText: "Successful saved. Operation ID: " + response })

        const { reloadDetails, handleClose } = this.props
        reloadDetails()
        setTimeout(handleClose, 1000)
      },
      error => this.setState({ error: error.text }),
      _ => this.setState({ running: false })
    )
  }

  render() {

    const { transactionAmount, showEdit, handleClose, isProcessRunning } = this.props,
    { success, running, error, successText, transactionDate } = this.state,

    title = transactionAmount ? 'Edit Transaction' : 'Delete Transaction',
    todayDate = moment().format('YYYY-MM-DD')

    return (
      <Modal show={ showEdit } onHide={ handleClose } >

        <Modal.Header closeButton>
          <Modal.Title>{ title }</Modal.Title>
        </Modal.Header>

        <Modal.Body>

          { transactionAmount 
          ? <div>

              <FormGroup controlId="transactionDate" validationState={ this.getDateValidationState() }>

                <ControlLabel>Transaction date</ControlLabel>

                <FormControl type="date" placeholder="Transaction Date"
                  value={ transactionDate }
                  onChange={e => this.setState({ transactionDate: e.target.value })}
                  min={ this.loanDate }
                  max={ todayDate }
                  />
                <HelpBlock>
                  Pick a date between { this.loanDate } and { todayDate }.
                </HelpBlock>

              </FormGroup>
              <br />

              <FieldGroup
                label="Transaction amount"
                id="transactionAmount"
                type="int"
                value={ this.state.transactionAmount.value }
                onChange={ this.state.transactionAmount.onChange }
                validationState={ this.state.transactionAmount.validation }
                validationMessage="Transaction amount must not be empty"
                bsClass="form-control"
              />
              <br />

            </div>

          : <h3>Are you sure you want to delete this transaction?</h3>
          }

          <ProcessesStatus
            error={ error }
            running={ running }
            success={ success }
            successText={ successText }
          />

        </Modal.Body>

        <Modal.Footer>
          <Button onClick={ handleClose }>Cancel</Button>
          <Button onClick={ this.makeAction } bsStyle="primary" 
            disabled={ isProcessRunning }>{ transactionAmount ? 'Update' : 'Delete' }</Button>
        </Modal.Footer>

      </Modal>
    )
  }
}

export default EditTransactionModalScreen



// WEBPACK FOOTER //
// ./src/components/Loans/EditTransactionModal.js